import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-label--light _mt-1 _flex _ac-c _jc-c _tac _px-1 _py-1 _fa--sm _rounded--common",
  "data-qa": "payment-info"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.component)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($options.component.component), _normalizeProps(_guardReactiveProps($options.component.props)), null, 16 /* FULL_PROPS */))
      ]))
    : _createCommentVNode("v-if", true)
}